module.exports = __webpack_public_path__ + "img/113.03a35172.jpg";